module.exports = __webpack_public_path__ + "static/media/dice-five.ab7c352e.svg";